import { render, staticRenderFns } from "./VideoTour.vue?vue&type=template&id=d8529064&"
import script from "./VideoTour.vue?vue&type=script&lang=js&"
export * from "./VideoTour.vue?vue&type=script&lang=js&"
import style0 from "./VideoTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports